import { createStore } from "./store";

export interface Prefs {
  sound: boolean; // sound effects
  volume: number; // 0..1
  /** null = automatic: the narrator speaks on the host device / single-device games only */
  narrator: boolean | null;
  haptics: boolean;
}

export const prefs = createStore<Prefs>(
  { sound: true, volume: 0.8, narrator: null, haptics: true },
  { persist: "hg:prefs", version: 1 },
);

/** Guest identity remembered for the next room (name + avatar). */
export interface Me {
  name: string;
  avatar: number | null;
}
export const me = createStore<Me>({ name: "", avatar: null }, { persist: "hg:me", version: 1 });

/** Seats in online rooms, so a refresh / locked phone rejoins the same player. */
export interface Seat {
  playerId: string;
  token: string;
  name: string;
  at: number;
}
export const seats = createStore<Record<string, Seat>>({}, { persist: "hg:seats", version: 1 });

export function saveSeat(code: string, seat: Omit<Seat, "at">) {
  seats.set((all) => {
    const next: Record<string, Seat> = { ...all, [code]: { ...seat, at: Date.now() } };
    // keep the 12 most recent rooms
    const keys = Object.keys(next).sort((a, b) => next[b].at - next[a].at);
    for (const k of keys.slice(12)) delete next[k];
    return next;
  });
}

export function dropSeat(code: string) {
  seats.set((all) => {
    if (!all[code]) return all;
    const next = { ...all };
    delete next[code];
    return next;
  });
}
